import {Step, StepType} from "./step";
import {Picture, PictureStatus, PictureType} from "./picture";
import {AnalysisStatusEnum} from "./analysis-status";
import {TyreAnalysis} from "./analysis";

export class TyrePicture extends Picture {
    step: Step;
    cbdValid?: boolean;

    constructor(step: Step) {
      super(step.toString(), PictureType.TYRE);
      this.step = step;
    }

  public static fromDB(picture: Picture){
      const tyrePicture = new TyrePicture(Step.fromString(picture.key));
      tyrePicture.status = picture.status;
      tyrePicture.uploadInfo = picture.uploadInfo;
      tyrePicture.data = picture.data;
      tyrePicture.url = picture.url;
      return tyrePicture;
  }

  /**
   * Builds a picture from a server tyre analysis (POST /v1/web-app/analyses response).
   * The server does not return the image data: the picture only carries the status,
   * so an already-uploaded position is not asked again on resume.
   * Returns undefined when the position is missing or not handled by the web app.
   */
  public static fromAnalysis(tyreAnalysis: TyreAnalysis, type: StepType): TyrePicture | undefined {
    if (!tyreAnalysis.position || tyreAnalysis.position < 1) {
      return undefined;
    }
    const picture = new TyrePicture(new Step(tyreAnalysis.position, type));
    picture.status = tyreAnalysis.status === AnalysisStatusEnum.STARTED ?
      PictureStatus.INVALID : PictureStatus.VALID;
    return picture;
  }
}
